<template>
  <SectionCard
    id="introduce"
    :class="isPcFlag ? 'product-introduction-pc' : 'product-introduction-h5'"
    :isPcFlag="isPcFlag"
    bgColor="#F8F9FB"
  >
    <div class="content-title">e签宝签管一体化电子合同云平台</div>
    <div class="introduction-content-text">
      <div class="text-item" v-for="item in dataListText" :key="item.key">
        <div class="text-title">{{ item.title }}</div>
        <div class="text-desc">{{ item.desc }}</div>
      </div>
    </div>
    <div class="introduction-content-card">
      <div class="item-content" v-for="(item, index) in dataListContent" :key="index">
        <div class="item-header">{{ item.title }}</div>
        <img class="item-img" :src="item.imgSrc" alt="" />
        <div class="item-desc">
          <p class="apply-obj">适用对象：{{ item.descListH5[0] }}</p>
          <p class="desc-content1">{{ item.descListH5[1] }}</p>
          <p class="desc-content2">{{ item.descListH5[2] }}</p>
        </div>
        <div class="kind-list">
          <div class="kind-item" v-for="i in item.kindList" :key="i.key">
            <img class="kind-img" :src="i.icon" alt="" />
            <p class="kind-text">{{ i.text }}</p>
          </div>
        </div>
        <div class="item-button" v-if="item.key == 1" @click="dialogShow">{{ item.buttonText + '>>' }}</div>
        <div class="item-button" v-else @click="OnlineConsultationClick">{{ item.buttonText + '>>' }}</div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataListContent: Array,
    dataListText: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  methods: {
    dialogShow() {
      this.$emit('showDialog')
    },
    OnlineConsultationClick() {
      this.$emit('OnlineConsultationClick')
    },
  },
}
</script>

<style lang="less" scoped>
@base-scale: calc((100vw / 375));
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.product-introduction-pc {
  .introduction-content-card {
    .item {
      width: 100%;
      height: 423px;
      background-color: #fff;
      box-shadow: 0px 2px 10px 0px #dee5f4;
      border-radius: 8px;
      margin-bottom: 30px;
      // .basisDisplay(center,center);
      .item-left {
        padding: 142px 109px 142px 64px;
        .title {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        .desc {
          width: 336px;
          margin: 10px 0 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 24px;
        }
        .text {
          .basisDisplay(center, center);
          width: 206px;
          height: 34px;
          background: #e63740;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
      }
      .vertical-bar {
        width: 1px;
        height: 360px;
        border: 1px solid #e8e8e8;
        margin: 31px 0;
      }
      .item-right-img {
        width: 58%;
        height: auto;
        padding: 15px;
        margin: 25px auto;
        .img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .item:nth-child(odd) .item-left {
      float: left;
    }
    .item:nth-child(odd) .vertical-bar {
      float: left;
    }
    .item:nth-child(odd) .item-right-img {
      float: right;
    }
    .item:nth-child(even) .item-left {
      float: right;
    }
    .item:nth-child(even) .vertical-bar {
      float: right;
    }
    .item:nth-child(even) .item-right-img {
      float: left;
    }
  }
}
// h5样式
.product-introduction-h5 {
  background: url('../../../assets/images/sem-pro/H5/promotion_bg.png') no-repeat !important;
  background-size: cover;
  padding: 0 !important;
  position: relative;
  .content-title {
    width: calc(@base-scale*234);
    height: calc(@base-scale*22);
    font-size: calc(@base-scale*16);
    font-weight: 500;
    margin: 0 auto;
    position: absolute;
    top: calc(@base-scale*32);
    left: calc(@base-scale*70);
  }
  .introduction-content-text {
    position: absolute;
    width: calc(@base-scale*301);
    height: calc(@base-scale*178);
    top: calc(@base-scale*86);
    left: calc(@base-scale*37);
    .text-item {
      margin-top: calc(@base-scale*20);
      height: calc(@base-scale*46);
      .text-title,
      .text-desc {
        font-size: calc(@base-scale*14);
        font-weight: 500;
        line-height: calc(@base-scale*19.6);
        text-align: center;
      }
      .text-desc {
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
      .text-title {
        color: rgba(230, 55, 64, 1);
      }
    }
    .text-item:nth-child(1) {
      margin-top: 0;
    }
  }
  .introduction-content-card {
    margin-top: calc(@base-scale*270);
    img {
      width: calc(@base-scale*100);
      height: calc(@base-scale*100);
    }
    .item-content {
      width: calc(@base-scale*345);
      border-radius: calc(@base-scale*4);
      box-shadow: 2px 2px 6px 0px rgba(205, 213, 226, 0.28);
      background-color: #fff;
      margin: 0 auto calc(@base-scale*24);
      border: 0;
      overflow: hidden;
      .item-header {
        height: calc(@base-scale*32);
        background-color: rgba(230, 55, 64, 1);
        font-size: calc(@base-scale*14);
        line-height: calc(@base-scale*32);
        text-align: center;
        color: #fff;
        font-weight: 500;
        border-radius: calc(@base-scale*4) calc(@base-scale*4) 0 0;
      }
      .item-img {
        float: right;
        margin-right: calc(@base-scale*6);
      }
      .item-desc {
        padding-left: calc(@base-scale*18);
        .apply-obj {
          height: calc(@base-scale*20);
          font-size: calc(@base-scale*14);
          color: rgba(0, 0, 0, 0.85);
          line-height: calc(@base-scale*19.6);
          margin-top: calc(@base-scale*20);
        }
        .desc-content1 {
          width: calc(@base-scale*209);
          font-size: calc(@base-scale*14);
          color: rgba(0, 0, 0, 0.65);
          line-height: calc(@base-scale*21);
          margin-top: calc(@base-scale*4);
        }
        .desc-content2 {
          height: calc(@base-scale*20);
          font-size: calc(@base-scale*14);
          color: rgba(0, 0, 0, 0.4);
          line-height: calc(@base-scale*19.6);
          margin-top: calc(@base-scale*10);
          margin-bottom: calc(@base-scale*10);
        }
      }
      .kind-list {
        height: calc(@base-scale*50);
        display: flex;
        flex-flow: column wrap;
        justify-content: space-between;
        .columnDisplay(center, flex-start);
        margin-left: calc(@base-scale*18);

        .kind-item {
          height: calc(@base-scale*22);
          .basisDisplay(left, center);

          .kind-img {
            width: calc(@base-scale*18);
            height: calc(@base-scale*18);
            margin-right: calc(@base-scale*6);
            // margin-right: 20px;
          }

          .kind-text {
            font-size: calc(@base-scale*14);
            color: rgba(0, 0, 0, 0.65);
            line-height: 22px;
            text-shadow: 0px 2px 4px #ffffff;
          }
        }
        .kind-item:nth-child(odd) {
          margin-bottom: calc(@base-scale*6);
        }
      }
    }
    .item-content:last-child {
      margin-bottom: 0;
    }
    .item-button {
      font-size: calc(@base-scale*15);
      font-weight: 400;
      text-align: left;
      height: calc(@base-scale*21);
      gap: 8px;
      color: rgba(230, 55, 64, 1);
      margin-left: calc(@base-scale*18);
      margin-top: calc(@base-scale*16);
      margin-bottom: calc(@base-scale*21);
    }
  }
}
</style>
